function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgSent2 = function SvgSent2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M2.042 14.013c.035 0 .07-.004.106-.01L12.577 12.5a.5.5 0 000-.989L2.148 10.007a1 1 0 00-.124-.01l-.028-6.01A2 2 0 014.9 2.192l15.97 8.092a2 2 0 01-.01 3.573L4.965 21.802a2 2 0 01-2.894-1.78l-.028-6.009z"
  }));
};
SvgSent2.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgSent2.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgSent2;